import PagePrice from '~components/PagePrice'

export default PagePrice
